import moment from "moment/moment";
import formatCurrency from "format-currency";
import createSubcontractModal from "../../../common/modals/createSubcontractModal/createSubcontractModal.component";


class SubcontractsController {
  constructor($rootScope, $http, toastr, $state, AuthenticationService, $uibModal) {
    "ngInject";
    this.name = 'subcontractors';
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.auth = AuthenticationService;
    this.toastr = toastr;
    this.$state = $state;
    this.customers = [];
    this.$uibModal = $uibModal;

    this.subcontractFilter = {
      name: '',
      status: 'active'
    }

    this.filterrefresh = false;


    let self = this;

    this.subcontractColumns = [
      {
        displayName: 'Number',
        value: 'number',
        sortable: true,
        dataType: 'text',
        formatting: function (record) {
          return "<a className=\"text-info\" href=\"admin/subcontracts/"+record.id+"\" >"+record.number+"</a>";
        }
      },
      {
        displayName: 'Subcontractor Name',
        value: 'subcontractorName',
        sortable: true,
        dataType: 'Text',
      },
      {
        displayName: 'Associated Contract',
        value: 'associatedContract.contractName',
        sortable: true,
        dataType: 'text'
      }
    ];

    this.filterCriteria = function () {
      return "";//name="+self.subcontractFilter.name;
    }

  }

 filterSubcontracts() {
    this.filterrefresh = true;
 }


  createSubcontract() {
    let self = this;
    var modalInstance = this.$uibModal.open(createSubcontractModal);

    modalInstance.success = function (subcontract) {
      self.$http.post(self.$rootScope.apiHost+'/api/admin/subcontractors/'+self.subcontractor.id+'/subcontracts', subcontract, { withCredentials: true}).then(function (success) {
        modalInstance.dismiss();
        self.$state.go("admin.subcontract-details", {'subcontractId': success.data.id});
        self.toastr.success("Successfully Created Subcontract", "SUCCESS");
      });
    };

    modalInstance.cancel = function () {
      modalInstance.dismiss();
    };
  }

}


export default SubcontractsController;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontracts/subcontracts.controller.js